import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async getOneById(colaboradorID = ""){

        let colaborador;

        try{

            colaborador = await ERP.getOneById(Schema.COLABORADOR, colaboradorID);
            if(colaborador.status != 200){
                throw colaborador;
            }

            console.log(colaborador);

        }catch(e){

            console.log(e);
            return colaborador;

        }

        return colaborador;

    },

    async getManyById(colaboradorIDs = []){

        let colaboradores;

        try{

            colaboradores = await ERP.getManyById(Schema.COLABORADOR, colaboradorIDs);
            if(colaboradores.status != 200){
                throw colaboradores;
            }

            console.log(colaboradores);

        }catch(e){

            console.log(e);
            return colaboradores;

        }

        return colaboradores;

    },

    async pegaColaboradorUsuario(colaboradorID = ""){

        let colaborador;

        try{

            colaborador = await this.getOneById(colaboradorID);
            if(colaborador.status != 200){
                throw colaborador;
            }

            console.log(colaborador);

        }catch(e){

            console.log(e);
            return colaborador;

        }

        return colaborador;

    },

    async pegaColaboradoresUsuario(colaboradorIDs = []){

        let colaboradores;

        try{

            colaboradores = await this.getManyById(colaboradorIDs);
            if(colaboradores.status != 200){
                throw colaboradores;
            }

            let colaboradoresOwners = colaboradores.data.map((colaborador)=>{

                if(colaborador?.user?.userId){
                    return colaborador?.user?.userId
                }else{
                    throw colaborador;
                }

            });

            colaboradores.data = colaboradoresOwners;

            console.log(colaboradores);

        }catch(e){

            console.log(e);
            colaboradores.status = 400;
            return colaboradores;

        }

        return colaboradores;

    },

}